import { Button } from 'antd';
import React, { useState } from 'react'
import { Row } from 'react-bootstrap'
import { Input_ } from 'services/Forms/FormsSatu.js'

function JitsiVC() {

    // const [room, setRoom] = useState("101083j373j2611j27");


    const params = new URLSearchParams(window.location.search);
    const room = params.get("room");

   
 

    return (
        <div>
            <Row>
                <Input_ suffix={<div> <Button> Kirim Ke WA </Button>.  <Button> Buka </Button> </div>} readonly label="Link Video Call" value={`https://meet.jit.si/${room}#config.prejoinPageEnabled=false`} />
            </Row>
        </div>
    )
}

export default JitsiVC
